// extracted by mini-css-extract-plugin
module.exports = {"link":"footer-module--link--3cG9_"};